import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { kInverted } from "assets/icons";

const ErrorMessage = ({ error }) => {
  const [t] = useTranslation("global");
  return (
    <div className={styles.errorMessage}>
      <div className={styles.subtitleWrapper}><img src={kInverted} alt = "k inverted icon"/><h2>{t("404.subtitle")}</h2></div>
      <div className= {styles.errorMessageText} dangerouslySetInnerHTML={{__html: t("404.text")}}></div>
    </div>
  );
};

export default ErrorMessage;
